import {localizeRepContent} from './rep-content-locales';

const normalize = value => (value || '')
  .toString()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const REP_SUPPORT_TOPICS = [
  {
    key: 'video-processing',
    aliases: ['video in elaborazione', 'video sta elaborando', 'video non e pronto', 'video non pronto', 'quanto ci mette il video', 'tempo elaborazione', 'video in processing', 'ancora in elaborazione', 'elaborazione del video'],
    title: 'Video in elaborazione',
    summary: 'Il filmato è stato acquisito, ma Replayer deve ancora completare upload, unione ed elaborazione prima di renderlo disponibile come video completo.',
    details: [
      'In condizioni normali il video completo può essere disponibile circa un’ora dopo l’evento.',
      'La durata dipende dalla lunghezza del filmato e dal carico: nei momenti di punta può richiedere diverse ore o arrivare alla notte.',
      'Non occorre acquistarlo di nuovo. Se disponibile, puoi chiedere di ricevere una notifica quando sarà pronto.'
    ],
    route: '/player-replayer-tv-home',
    actionLabel: 'Controlla nella ReplayerTV'
  },
  {
    key: 'copy-my-video',
    aliases: ['copia in my video', 'copiare in my video', 'copia video', 'mettere in my video', 'sposta in my video', 'devo pagare di nuovo per copiarlo'],
    title: 'Copia in My Video',
    summary: 'Copia in My Video aggiunge un contenuto a cui hai già accesso nella tua area personale: non è un secondo acquisto.',
    details: [
      'Il comando diventa disponibile quando il video completo ha terminato l’elaborazione e il tuo accesso è valido tramite acquisto, abbonamento o affiliazione prevista dal canale.',
      'Da My Video puoi organizzare il contenuto in cartelle e usare le funzioni disponibili, come Highlight, Tag e Playlist.',
      'La copia utilizza lo spazio del tuo piano My Video; se lo spazio non basta, Replayer te lo segnala.'
    ],
    route: '/player-video?section=video',
    actionLabel: 'Apri My Video'
  },
  {
    key: 'video-unavailable',
    aliases: ['video non disponibile', 'video non e disponibile', 'video sparito', 'non trovo piu il video', 'non riesco a vedere il video', 'perche non vedo il video', 'video scaduto'],
    title: 'Video non disponibile',
    summary: '“Video non disponibile” è diverso da “Video in elaborazione”: indica che in quel momento il contenuto non può essere riprodotto o acquisito da quella card.',
    details: [
      'Controlla prima se la card indica elaborazione: in quel caso devi solo attendere che il processo termini.',
      'Se non è in elaborazione, verifica accesso, acquisto, abbonamento o affiliazione e l’eventuale data di disponibilità indicata nella card.',
      'Se avevi già copiato il contenuto, cercalo in My Video. Se lo stato resta incoerente, comunica all’assistenza centro, data, campo e titolo del video.'
    ],
    route: '/player-video?section=video',
    actionLabel: 'Cerca in My Video'
  },
  {
    key: 'subscription-price',
    aliases: ['quanto costa un abbonamento', 'costo abbonamento', 'prezzo abbonamento', 'quanto costa la replayertv', 'abbonamenti replayertv', 'abbonamento replayertv'],
    title: 'Costo di un abbonamento ReplayerTV',
    summary: 'Non esiste un prezzo unico: ogni società definisce i propri piani, la durata e i contenuti inclusi. Il prezzo aggiornato è sempre mostrato nella sua ReplayerTV prima della conferma.',
    details: [
      'Apri la ReplayerTV della società e confronta i piani disponibili.',
      'Controlla durata, rinnovo e contenuti inclusi: alcune dirette o partite possono anche essere gratuite.',
      'Se vuoi una sola partita, verifica la card: quando previsto puoi acquistare il singolo video senza sottoscrivere un abbonamento.'
    ],
    route: '/player-replayer-tv-home',
    actionLabel: 'Confronta gli abbonamenti'
  },
  {
    key: 'single-video-purchase',
    aliases: ['acquistare singolo video', 'comprare singolo video', 'comprare una partita', 'acquistare una partita', 'posso comprare solo una partita', 'senza abbonamento', 'prezzo singolo video', 'quanto costa un video'],
    title: 'Acquisto di un singolo video',
    summary: 'Quando la società abilita la vendita singola, puoi acquistare quel video senza abbonarti. La disponibilità e il prezzo sono indicati direttamente nella card.',
    details: [
      'Il prezzo può variare in base alla durata del contenuto e alle regole impostate dalla società.',
      'L’importo viene scalato dal credito Replayer; se il saldo è insufficiente puoi ricaricarlo prima di confermare.',
      'Se il video deve ancora essere elaborato, riceverai l’accesso quando sarà pronto; non devi ripetere l’acquisto.'
    ],
    route: '/player-replayer-tv-home',
    actionLabel: 'Cerca un video acquistabile'
  },
  {
    key: 'subscription-or-single',
    aliases: ['meglio abbonamento o singolo video', 'abbonamento o singola partita', 'differenza abbonamento singolo video', 'conviene abbonamento'],
    title: 'Abbonamento o singolo video?',
    summary: 'Dipende da quanti contenuti vuoi vedere nella stessa ReplayerTV: Rep può aiutarti a confrontare le opzioni mostrate dal canale, ma la scelta e la conferma restano sempre tue.',
    details: [
      'Il singolo acquisto è adatto quando ti interessa una partita specifica ed è abilitato dalla società.',
      'L’abbonamento può includere più contenuti pianificati nel periodo di validità; verifica sempre cosa comprende.',
      'Eventi gratuiti, accessi da affiliazione e promozioni possono rendere non necessario né l’acquisto né l’abbonamento.'
    ],
    route: '/player-replayer-tv-home',
    actionLabel: 'Apri ReplayerTV'
  },
  {
    key: 'purchased-video-location',
    aliases: ['dove trovo il video acquistato', 'dove trovo il video comprato', 'video che ho comprato', 'video che ho acquistato', 'ho comprato un video', 'video acquistato non si vede', 'quando arriva il video acquistato'],
    title: 'Dove trovare un video acquistato',
    summary: 'Subito dopo l’acquisto il contenuto può essere ancora in elaborazione. Replayer lo rende disponibile appena il filmato completo è pronto e può inviarti una notifica.',
    details: [
      'I Partner Video acquistati vengono aggiunti direttamente a My Video.',
      'Per gli altri contenuti segui lo stato nella Home o nella ReplayerTV e usa “Copia in My Video” quando viene abilitato.',
      'Se l’acquisto risulta nelle transazioni ma il contenuto non compare dopo l’elaborazione, segnala all’assistenza titolo, società, data e ora.'
    ],
    route: '/player-video?section=video',
    actionLabel: 'Controlla My Video'
  }
];

export const findRepSupportTopic = (query, language = 'it') => {
  const normalized = normalize(query);
  return REP_SUPPORT_TOPICS
    .map(topic => localizeRepContent(topic, 'support', language))
    .find(topic => topic.aliases.some(alias => normalized.includes(normalize(alias)))) || null;
};
